import React from 'react';
import { Grid, Typography, Accordion, AccordionSummary, AccordionDetails, List, ListItem, Paper, Box } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import BlockIcon from '@mui/icons-material/Block';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const ReadOnlyDisplay = ({
    userData,
    allowNets
}) => {
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return dateString;
        
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const time = date.toLocaleTimeString();
        
        return `${day}/${month}/${year}, ${time}`;
    };

    return (
        <Paper variant="outlined" sx={{ p: 1.5, mt: 1.5, mb: 1, bgcolor: '#fafafa', borderRadius: 2 }}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>Account Information</Typography>
            <Grid container spacing={1}>
                <Grid item xs={12} sm={6} md={3}>
                    <Typography variant='caption' color="textSecondary">Used Quota</Typography>
                    <Typography variant='body2'>{userData.mailbox_data.used_quota}</Typography>
                </Grid>
                {userData.mailbox_data.password_reset_datetime && (
                    <Grid item xs={12} sm={6} md={3}>
                        <Typography variant='caption' color="textSecondary">Password Reset Date</Typography>
                        <Typography variant='body2'>{formatDate(userData.mailbox_data.password_reset_datetime)}</Typography>
                    </Grid>
                )}
                
                <Grid item xs={12} sm={6} md={3}>
                    <Typography variant='caption' color="textSecondary">Password Status</Typography>
                    {userData.mailbox_data.is_password_expired ? (
                        <Typography variant='body2' color="error" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <BlockIcon fontSize="small" /> Expired
                        </Typography>
                    ) : (
                        <Typography variant='body2' color="success.main" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <CheckCircleOutlineIcon fontSize="small" /> Active
                        </Typography>
                    )}
                </Grid>
                
                {userData.access_restrictions.allow_nets && (
                    <Grid item xs={12} sm={6} md={3}>
                        <Typography variant='caption' color="textSecondary">Allowed IPs</Typography>
                        <Typography variant='body2'>{allowNets}</Typography>
                    </Grid>
                )}
                
                {userData.mailbox_data.created && (
                    <Grid item xs={12} sm={6} md={3}>
                        <Typography variant='caption' color="textSecondary">Created At</Typography>
                        <Typography variant='body2'>{formatDate(userData.mailbox_data.created)}</Typography>
                    </Grid>
                )}
                
                {userData.mailbox_data.last_login_datetime && (
                    <Grid item xs={12} sm={6} md={3}>
                        <Typography variant='caption' color="textSecondary">Last Login Date</Typography>
                        <Typography variant='body2'>{formatDate(userData.mailbox_data.last_login_datetime)}</Typography>
                    </Grid>
                )}
                
                {userData.mailbox_data.last_login_ip_address && (
                    <Grid item xs={12} sm={6} md={3}>
                        <Typography variant='caption' color="textSecondary">Last Login IP</Typography>
                        <Typography variant='body2'>{userData.mailbox_data.last_login_ip_address}</Typography>
                    </Grid>
                )}
                
                {userData.associated_group_ids?.length > 0 && (
                    <Grid item xs={12}>
                        <Accordion variant='outlined' sx={{ mt: 0.5 }} size="small">
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ minHeight: '32px', '& .MuiAccordionSummary-content': { margin: '8px 0' } }}>
                                <Typography variant='body2'>Associated Group IDs</Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ pt: 0, pb: 1 }}>
                                <List dense disablePadding>
                                    {userData.associated_group_ids.map((item, index) => (
                                        <ListItem key={index} disableGutters sx={{ py: 0 }}>
                                            <Typography variant="body2">{item}</Typography>
                                        </ListItem>
                                    ))}
                                </List>
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                )}
            </Grid>
        </Paper>
    );
}

export default ReadOnlyDisplay;